<template>
    <actions-menu
        :Id="Id"
        :dialogEditUrl="idBrand"
        v-model:dialogDelete="dialog"
        dialogEdit="DelivryCompanyDetails"
        :ShowDialogDelete="false"
        :ShowDialogStatus="false"
        :status="afficheActive"
        v-model:dialogStatus="dialogStatus"
        :ValidationStatus="localStatus"
    />
    
    <dialogDelete
        DialogType="Status"
        v-model="dialogStatus"
        :status="afficheActive"
        :yes="ChangeStatus"
        width="450px"
        :loader="loader"
    />
</template>

<script>
import DialogDelete from "@/genericComponent/dialogDelete.vue";
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import { deactivateCompanyAccount } from "@/api/index";

export default {
    components: { actionsMenu, DialogDelete },
    props: {
        idBrand: String,
        Id: String, 
        getBrandListAfterDelete: Function, 
        status: Boolean, 
    },
    data() {
        return {
            dialogConsult: false,
            isEditMode: true,
            dialog: false,
            dialogStatus: false, 
            localStatus: this.status,
            afficheActive: null,
            loader : false,
        };
    },
    created(){
        this.afficheActive = this.status === false ? null : 'value';

    },
    watch: {
        status(newVal) {
            this.localStatus = newVal;
        }
    },
    methods: {
        async ChangeStatus() {
            try {
                this.loader = true;
                this.dialogStatus = true;

                const newStatus = !this.localStatus;
                this.afficheActive = this.status === false ? null : 'value';
                const result = await deactivateCompanyAccount(this.idBrand, newStatus);

                if (result) {
                    this.localStatus = newStatus; 
                    this.dialogStatus = false; 

                    this.$emit("update:status", newStatus);

                    if (this.getBrandListAfterDelete) {
                        this.getBrandListAfterDelete();
                    }
                }
            } catch (error) {
                console.error("Échec de la mise à jour du statut :", error);
            }
            this.loader = false;
        },
    },
};
</script>
